<p-dialog header="Prescription" *ngIf="displayModel" [(visible)]="displayModel" [modal]="true"
    [contentStyle]="{'overflow':'scroll'}" styleClass="p-dialog-width" [baseZIndex]="10000" [draggable]="false"
    id="prescription" [resizable]="false" (onHide)="CloseDialog()" [style]="{'width':'80%'}">
    <div class="col-md-12">
        <ng-container *ngIf="this.prescriptionData.consultation.p_prescriptions.length > 0">
            <p-button icon="pi pi-check" (click)="print()" label="Print" styleClass="p-button-text"></p-button>

            <app-prescription-details [data]="prescriptionData" [dataId]='showPrescriptiond'></app-prescription-details>

        </ng-container>
        <ng-container *ngIf="this.prescriptionData.consultation.p_prescriptions.length == 0">
            <p>Prescription not available</p>
        </ng-container>
        <h4 *ngIf="this.posting">Fetching data...</h4>
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="this.posting" strokeWidth="6">
        </p-progressSpinner>
    </div>
</p-dialog>
<app-prescription-details *ngIf="displayModel" [data]="this.prescriptionData" [dataId]='printContent'>
</app-prescription-details>

<ng-container *ngIf="displayModel1">
    <p-dialog header="Report" [(visible)]="displayModel1" [modal]="true" [contentStyle]="{'overflow':'scroll'}"
        [style]="{width: '100vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
        (onHide)="CloseDialog()">

        <div *ngIf="this.doctorReportsSuccessd!=null && this.doctorReportsSuccessd==true">

            <div class="spaces"></div>

            <app-doctorreportpdf [data]='this.doctorReportsData' [dataId]='showDoctorReportsd'></app-doctorreportpdf>

            <p-button icon="pi pi-check" (click)="print()" label="Print" styleClass="p-button-text"></p-button>

        </div>

    </p-dialog>

    <div *ngIf="this.doctorReportsSuccessd!=null && this.doctorReportsSuccessd==true">

        <div class="spaces"></div>

        <app-doctorreportpdf [data]='this.doctorReportsData' [dataId]='printContent'></app-doctorreportpdf>

    </div>
</ng-container>
<div *ngIf="success">
    <div class="card no-margin">
        <div class="ui-g ui-fluid">
            <div class="ui-g-12">
                <div class="ui-g form-group">
                    <div class="ui-g-12 ui-md-4">
                        <div class="ui-g-12 ui-md-4" style="display: table; height: 200px; overflow: hidden;">
                            <div style="display: table-cell; vertical-align: middle; text-align:center;">
                                <img [src]="(view_health_data.patient.avatar_url==null || 
                                (view_health_data.patient.avatar_url!=null && view_health_data.patient.avatar_url.length==0)) 
                                ?'./assets/images/test_profile.png':view_health_data.patient.avatar_url"
                                    style="border-radius: 50%;margin-right:auto;margin-left:2em;" height='160'
                                    width='160'>
                            </div>
                        </div>
                    </div>

                    <div class="ui-g-12 ui-md-8">
                        <div class="ui-g-12 ui-md-8">
                            <label><b>Patient Name :</b> </label>
                            <span class="notranslate">
                                {{view_health_data.patient.first_name+" "+(view_health_data.patient.middle_name==null?'':view_health_data.patient.middle_name)+"
                                "+view_health_data.patient.last_name | titlecase}}</span>
                        </div>
                        <div class="ui-g-12 ui-md-8">
                            <label><b>Gender :</b> </label>
                            <span> {{view_health_data.patient.gender | titlecase}} </span>
                        </div>
                        <div class="ui-g-12 ui-md-8">
                            <label><b>Age : </b></label>
                            <span> {{patient_age+" years"}} </span>
                        </div>
                        <div class="ui-g-12 ui-md-8">
                            <label><b>DOB :</b> </label>
                            <span> {{view_health_data.patient.date_of_birth | date}} </span>
                        </div>

                        <div class="ui-g-12 ui-md-8">
                            <label><b>Unique Identification :</b> </label>
                            <span> {{view_health_data.patient.identification_type | titlecase}} </span>
                            <a (click)="showviewall()" class="clickable"> <i class="pi pi-file"></i> View Identification
                                Document </a>
                        </div>
                    </div>
                </div>
                <p-dialog header="Unique Identification" *ngIf="display" [resizable]="false" responsive="true"
                    [(visible)]="display">
                    <div class="ui-g-12" style="display: table;">
                        <div class="text  text-center" style="display: table-cell;">
                            <img class="circle-icon" style="height: 200px; width: 440px;" [src]="(view_health_data.patient.identification_url==null ||
                                (view_health_data.patient.identification_url!=null && 
                                view_health_data.patient.identification_url.length==0)) ?
                                './assets/images/aboutUs1.png':view_health_data.patient.identification_url">
                        </div>
                    </div>
                </p-dialog>
            </div>
        </div>
    </div>


    <div class="card card-w-title" *ngIf="view_health_data?.consultation?.condition_description!=null">
        <p-fieldset [style]="{'border':'2px solid #004aad'}">
            <p-header class="pheader">Chief Medical Complaint</p-header>
            <div class="ui-g">
                <textarea style="color: black; opacity: inherit;float: left;" [rows]="5" [cols]="120" pInputTextarea
                    class="col-12 WordWrap format-lines" disabled name="pastmedic "
                    id="pastmedic ">{{view_health_data.consultation.condition_description}}</textarea>
            </div>
        </p-fieldset>
    </div>
    <div class="card no-margin" *ngFor='let ert of textarea'>
        <div class="card card-w-title">
            <p-fieldset [style]="{'border':'2px solid #004aad'}">
                <p-header class="pheader">Past Medical History</p-header>
                <div class="ui-g">
                    <textarea style="color: black; opacity: inherit;float: left;" [rows]="5" [cols]="120" pInputTextarea
                        class="col-12 WordWrap format-lines" disabled name="pastmedic "
                        id="pastmedic ">{{ert.past_medical_history}}</textarea>
                </div>
            </p-fieldset>
        </div>
        <div class="card card-w-title">
            <p-fieldset [style]="{'border':'2px solid #004aad'}">
                <p-header class="pheader">Past Surgical History</p-header>
                <div class="ui-g">
                    <textarea style="color: black; opacity: inherit;float: left;" [rows]="5" [cols]="120" pInputTextarea
                        class="col-12 WordWrap format-lines" disabled name="pastmedic "
                        id="pastmedic ">{{ert.past_surgical_history}}</textarea>
                </div>
            </p-fieldset>
        </div>
        <div class="card card-w-title">
            <p-fieldset [style]="{'border':'2px solid #004aad'}">
                <p-header class="pheader">Medication</p-header>
                <div class="ui-g">
                    <textarea style="color: black; opacity: inherit;float: left;" [rows]="5" [cols]="120" pInputTextarea
                        class="col-12 WordWrap format-lines" disabled name="pastmedic "
                        id="pastmedic ">{{ert.medication}}</textarea>
                </div>
            </p-fieldset>
        </div>

        <div class="card card-w-title">
            <p-fieldset [style]="{'border':'2px solid #004aad'}">
                <p-header class="pheader">Allergies</p-header>
                <div class="ui-g">
                    <textarea style="color: black; opacity: inherit;float: left;" [rows]="5" [cols]="120" pInputTextarea
                        class="col-12 WordWrap format-lines" disabled name="pastmedic "
                        id="pastmedic ">{{ert.allergy}}</textarea>
                </div>
            </p-fieldset>
        </div>
        <div class="card card-w-title">
            <p-fieldset [style]="{'border':'2px solid #004aad'}">
                <p-header class="pheader">Social History</p-header>
                <div class="ui-g">
                    <textarea style="color: black; opacity: inherit;float: left;" [rows]="5" [cols]="120" pInputTextarea
                        class="col-12 WordWrap format-lines" disabled name="pastmedic "
                        id="pastmedic ">{{ert.social_history}}</textarea>
                </div>
            </p-fieldset>
        </div>
        <div class="card card-w-title">
            <p-fieldset [style]="{'border':'2px solid #004aad'}">
                <p-header class="pheader">Family History</p-header>
                <div class="ui-g">
                    <textarea style="color: black; opacity: inherit;float: left;" [rows]="5" [cols]="120" pInputTextarea
                        class="col-12 WordWrap format-lines" disabled name="pastmedic "
                        id="pastmedic ">{{ert.family_history}}</textarea>
                </div>
            </p-fieldset>
        </div>

        <div class="card card-w-title">
            <p-fieldset [style]="{'border':'1px solid #000000'}">
                <p-header class="pheader">Uploaded Reports</p-header>
                <div class="ui-g">
                    <div class="ui-g-12">
                        <div *ngIf="(this.MedicalReports.data.api_result.PromiseResult?.success!=null)">
                            <app-document-viewer [data]="this.MedicalReports.data.api_result"></app-document-viewer>
                        </div>
                    </div>
                    <app-error-messages [api_result]="this.MedicalReports.data.api_result"></app-error-messages>
                </div>
                <br>
            </p-fieldset>
        </div>
        <div class="card card-w-title" style="text-align: center;">
            <p-fieldset [style]="{'border':'2px solid #004aad'}">
                <p-header class="pheader">Previous eGlobalDoctor Consultations</p-header>
                <p-table #dt1 [value]="consultations" dataKey="id" styleClass="p-datatable-customers" [rows]="10"
                    [paginator]="true" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10,25,50]" [globalFilterFields]="[ 
                            'consultation_date',
                        'specialty_name',
                        'priority_type',
                        'priority_type',
                        'doctor_name']">

                    <ng-template pTemplate="caption">
                        <div class="table-header float-right">
                            <span class="p-input-icon-left">

                                <input pInputText type="text"
                                    (input)="dt1.filterGlobal($event.target.value, 'contains')" placeholder="Search"
                                    style="width:250px;margin-left:75%;" />
                            </span>
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 100px;" pSortableColumn="sr_no"><b>Sr. No.</b>
                                <p-sortIcon field="sr_no"></p-sortIcon>
                            </th>
                            <th pSortableColumn="consultation_date"><b>Consultation Date</b>
                                <p-sortIcon field="consultation_date"></p-sortIcon>
                            </th>
                            <th pSortableColumn="specialty_name"><b>Specialty</b>
                                <p-sortIcon field="specialty_name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="priority_type" style="width: 100px;"><b>Priority</b>
                                <p-sortIcon field="priority_type"></p-sortIcon>
                            </th>
                            <th pSortableColumn="doctor_name"><b>Doctor</b>
                                <p-sortIcon field="doctor_name"></p-sortIcon>
                            </th>
                            <th><b>Report</b></th>
                            <th><b>Prescription</b></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-consultation>
                        <tr [pSelectableRow]="consultation">
                            <td style="width: 100px;">
                                {{consultation.sr_no+1}}
                            </td>
                            <td>

                                <span>{{consultation.consultation_date | date}}</span>
                            </td>
                            <td>
                                <span *ngFor="let sp of consultation.specialty_name">
                                    <p-message severity="success" text="{{sp}}"></p-message>
                                </span>
                            </td>
                            <td style="width: 100px;">
                                <span>{{consultation.priority_type}}</span>
                            </td>
                            <td>
                                <span *ngFor="let sp of consultation.doctor_name">
                                    <p-message severity="success" text="{{sp}}"></p-message>
                                </span>
                            </td>
                            <td>
                                <ng-container *ngIf='consultation.consultation_status=="CLOSED"'>
                                    <span>
                                        <p-button (click)=" gotoReportpdf(consultation.consultation_id)"
                                            icon="pi pi-external-link" label="View"></p-button>
                                    </span>
                                </ng-container>
                                <ng-container *ngIf='consultation.consultation_status!="CLOSED"'>
                                    N/A
                                </ng-container>
                            </td>
                            <td>
                                <ng-container *ngIf='consultation.consultation_status=="CLOSED"'>
                                    <span>
                                        <p-button (click)="gotoprescription(consultation.consultation_id)"
                                            icon="pi pi-external-link" label="View">
                                        </p-button>
                                    </span>
                                </ng-container>
                                <ng-container *ngIf='consultation.consultation_status!="CLOSED"'>
                                    N/A
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="7">No Data found.</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft">
                    </ng-template>
                    <ng-template pTemplate="paginatorright">
                    </ng-template>
                </p-table>
            </p-fieldset>
        </div>
        <div class="card card-w-title" *ngIf="show_prescription_id!=-1" style="text-align: center;">
            <p-fieldset [style]="{'border':'1px solid #000000'}">
                <p-header class="pheader">Prescriptions</p-header>
                <p-table #dt2 [value]="prescriptions" dataKey="id" styleClass="p-datatable-customers" [rows]="10"
                    [paginator]="true" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10,25,50]" [globalFilterFields]="[ 
                'medication_name',
                'dosage',
                'times_per_day',
                'no_of_days'
                ]">

                    <ng-template pTemplate="caption">
                        <div class="table-header float-right">
                            <span class="p-input-icon-left">

                                <input pInputText type="text"
                                    (input)="dt1.filterGlobal($event.target.value, 'contains')" placeholder="Search"
                                    style="width:250px;margin-left:75%;" />
                            </span>
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="medication_name"><b>Medication</b>
                                <p-sortIcon field="medication_name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="dosage"><b>Dosage</b>
                                <p-sortIcon field="dosage"></p-sortIcon>
                            </th>
                            <th pSortableColumn="times_per_day"><b>Times per Day</b>
                                <p-sortIcon field="times_per_day"></p-sortIcon>
                            </th>
                            <th pSortableColumn="no_of_refills"><b>No. of Refills</b>
                                <p-sortIcon field="no_of_refills"></p-sortIcon>
                            </th>
                            <th pSortableColumn="comments"><b>Comments</b>
                                <p-sortIcon field="comments"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-prescription>
                        <tr [pSelectableRow]="prescription">
                            <td>

                                {{prescription.medication_name}}
                            </td>
                            <td>

                                <span>{{prescription.dosage}}</span>
                            </td>
                            <td>

                                <span>{{prescription.times_per_day}}</span>
                            </td>
                            <td>

                                <span>{{prescription.no_of_refills}}</span>
                            </td>
                            <td>

                                <span>{{prescription.comments}}</span>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="4">No Data found.</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft">
                    </ng-template>
                    <ng-template pTemplate="paginatorright">
                    </ng-template>
                </p-table>
            </p-fieldset>
        </div>
    </div>
</div>


<div class="row container justify-content-center text-center alert alert-danger"
    *ngIf="response?.success!=null && response?.success==false">
    <p *ngIf="response?.error!=null">{{response?.error?.message}}</p>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
        <p *ngFor="let message of serverError?.message">{{message}}</p>
    </div>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
        <p>{{serverError?.message}}</p>
    </div>

</div>
<h4 *ngIf="posting">Fetching Patient data...</h4>
<p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="posting" strokeWidth="6">